import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-animation-preview',
  templateUrl: './animation-preview.component.html',
  styleUrls: ['./animation-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AnimationPreviewComponent implements OnChanges {
  @Input() imageUrl: string;
  @Input() name = 'Animation';
  @Input() fps = 10;
  @Input() isPattern = false;

  private image: HTMLImageElement;
  private canvas: HTMLCanvasElement;

  frameCount = 0;
  loaded = false;
  failed = false;
  playing = false;

  get duration(): number {
    const fps = Number.isFinite(this.fps) && this.fps > 0 ? this.fps : 10;
    return this.frameCount / fps;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.imageUrl) {
      this.frameCount = 0;
      this.loaded = false;
      this.failed = false;
      this.playing = false;
    } else if (changes.isPattern && this.loaded) {
      this.drawSprite();
    }
  }

  imageLoaded(event: Event, canvas: HTMLCanvasElement): void {
    const image = event.target as HTMLImageElement;
    if (image.naturalWidth !== 12 || image.naturalHeight <= 0 || image.naturalHeight % 10 !== 0) {
      this.imageFailed();
      return;
    }

    this.image = image;
    this.canvas = canvas;
    this.frameCount = image.naturalHeight / 10;
    this.loaded = true;
    this.failed = false;
    this.drawSprite();
    this.playing = this.loaded && this.frameCount > 1;
  }

  private drawSprite(): void {
    this.canvas.width = this.image.naturalWidth;
    this.canvas.height = this.image.naturalHeight;
    const context = this.canvas.getContext('2d');
    if (!context) {
      this.imageFailed();
      return;
    }
    context.drawImage(this.image, 0, 0);
    if (this.isPattern) {
      const frame = context.getImageData(0, 0, this.canvas.width, this.canvas.height);
      // Patterns use black pixels as a color mask; preserve alpha and colored details.
      for (let offset = 0; offset < frame.data.length; offset += 4) {
        if (frame.data[offset] === 0 && frame.data[offset + 1] === 0 && frame.data[offset + 2] === 0) {
          frame.data[offset] = frame.data[offset + 1] = frame.data[offset + 2] = 255;
        }
      }
      context.putImageData(frame, 0, 0);
    }
  }

  imageFailed(): void {
    this.frameCount = 0;
    this.loaded = false;
    this.failed = true;
    this.playing = false;
  }
}
